var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"row","wrap":"wrap"}},_vm._l((_vm.options[_vm.userStorage.privileges]),function(option,index){return _c('v-flex',{key:option.src,attrs:{"md4":"md4","xs4":"xs4"}},[_c('router-link',{attrs:{"to":option.route}},[_c('img',{attrs:{"src":option.src}})])],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7277e306","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Item.vue
// module id = null
// module chunks = 